import type { SumsubMode, SumsubSettingsResponse } from "@repo/shared/types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import * as sumsubApi from "@/lib/api/sumsub";

export function useSumsubSettings() {
  const { data, error, isLoading } = useQuery({
    queryKey: ["sumsub-settings"],
    queryFn: () => sumsubApi.getSettings(),
  });
  const queryClient = useQueryClient();
  const mutate = () => queryClient.invalidateQueries({ queryKey: ["sumsub-settings"] });
  return {
    settings: data ?? null,
    error,
    isLoading,
    mutate,
  };
}

/**
 * Read-only access to the tenant's Sumsub mode for surfaces outside the settings page
 * (flow editor add-component gating, public flow rendering). The GET /internal/sumsub/settings
 * endpoint is session-gated only, so any authenticated user can resolve the mode.
 */
export function useSumsubMode(): { sumsubMode: SumsubMode | null; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ["sumsub-settings"],
    queryFn: () => sumsubApi.getSettings(),
    select: (d) => d.sumsubMode,
  });
  return { sumsubMode: data ?? null, isLoading };
}

export type { SumsubSettingsResponse };
